<template>
  <el-dialog
    v-dialogDrag
    class="small-dialog"
    :append-to-body="true"
    :visible.sync="visible"
    title="隐患治理延期"
  >
    <el-form ref="form" label-width="170px" :model="formData" v-loading="loading">
      <el-form-item
        label="原有计划整改期限时间"
        prop="hiddenDangerRectificationPeriod"
        :rules="[
          {
            required: true,
            message: `请输入原有计划整改期限时间`,
            trigger: 'change,blur',
          },
        ]"
      >
        <el-date-picker
          v-model="formData.hiddenDangerRectificationPeriod"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="原有计划整改期限时间"
          disabled
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="计划延期时间"
        prop="deferralTime"
        :rules="[
          {
            required: true,
            validator: validatorDate,
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-date-picker
          v-model="formData.deferralTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="请选择计划延期时间"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>

      <el-form-item
        label="延期原因"
        prop="hiddenDangersRectificationDelayReason"
        :rules="[
          {
            required: true,
            message: `请输入延期原因`,
            trigger: ['change', 'blur'],
          },
        ]"
      >
        <el-input
          v-model="formData.hiddenDangersRectificationDelayReason"
          placeholder="请输入延期原因"
          maxlength="200"
          type="textarea"
          :rows="3"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="申请人" prop="hiddenDangerRectificationExtensionApplicantId">
        <person-select
          :disabled="true"
          v-model="formData.hiddenDangerRectificationExtensionApplicantId"
        ></person-select>
      </el-form-item>
      <!--
      <el-form-item
        label="审核人"
        prop="receiverIds"
        :rules="[
          {
            required: true,
            message: `请选择延期审核人`,
            trigger: ['blur', 'change'],
          },
        ]"
      >
        <el-select
          v-model="formData.receiverIds"
          placeholder="请选择"
          clearable
          filterable
          multiple
        >
          <el-option
            v-for="item in confirmUsers"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    -->
      <el-form-item label="申请时间" prop="hiddenDangerRectificationExtensionApplicationTime">
        <el-date-picker
          disabled
          v-model="formData.hiddenDangerRectificationExtensionApplicationTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          placeholder="请输入申请时间"
        ></el-date-picker>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <el-button
        :loading="loading"
        size="small"
        type="primary"
        class="iconfont icon-save"
        @click="save()"
        >保存</el-button
      >
      <el-button size="small" class="iconfont icon-close" @click="visible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import dayjs from 'dayjs'
import PersonSelect from '@/components/safety/FormSelect/PersonSelect'
import DiyService from '../../services/DiyService'

const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()
export default {
  name: 'delay-form',
  props: {
    FormData: {
      default: '',
    },
  },
  components: { PersonSelect },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('cancel')
      }
    },
  },
  data() {
    return {
      workFlowDesignId: '',
      workFlowNodeId: '',
      confirmUsers: [],
      visible: true,
      loading: false,
      formData: {},
      pickerOptions: {
        disabledDate(v) {
          return dayjs(v).format('YYYY-MM-DD') < dayjs().format('YYYY-MM-DD')
        },
      },
    }
  },
  computed: {},
  methods: {
    // 获取用户列表
    async getNodeConfirmUsers() {
      const [err, res] = await DiyService.getNodeConfirmUsers({
        NodeId: this.workFlowNodeId,
        ApprovalType: 'Agree',
      })
      if (!err && res.Code === 1 && res.Data && res.Data.SelectUsers) {
        this.confirmUsers = res.Data.SelectUsers
      }
    },
    // 获取流程
    async getWorkFlowDesign() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_FlowDesign',
        _PageSize: 15,
        _PageIndex: 1,
        _Where: [{ Name: 'FlowName', Value: '隐患治理延期子流程', Type: 'Like' }],
      })
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentFlowDesign = _.find(res.Data, ['FlowName', '隐患治理延期子流程'])
        if (currentFlowDesign) {
          this.workFlowDesignId = currentFlowDesign.Id
        }
      }
    },
    // 获取流程节点
    async getWorkFlowNodes() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'WF_Node',
        _SearchEqual: { FlowDesignId: this.workFlowDesignId },
      })
      console.log(res)
      if (!err && res && res.Code === 1 && res.Data && res.Data.length) {
        const currentNode = _.find(res.Data, ['NodeName', '延期审核'])
        if (currentNode) {
          this.workFlowNodeId = currentNode.Id
        }
      }
    },
    validatorDate(rule, value, callback) {
      if (!value) {
        callback(new Error('延期时间不能为空!'))
        return
      }
      if (new Date(this.formData.hiddenDangerRectificationPeriod) > new Date(value)) {
        callback(new Error('延期时间必须大于原有整改期限时间!'))
        return
      }
      if (new Date() > new Date(value)) {
        callback(new Error('延期时间必须大于当前时间!'))
        return
      }
      callback()
    },
    save() {
      if (!this.formData.id) {
        this.$message({
          showClose: true,
          message: '此条数据缺少id',
          type: 'warning',
        })
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true
          const [
            err,
            res,
          ] = await hiddenDangerRectificationChecklistApi.hiddenDangersRectificationPostponeSubmit({
            id: this.formData.id,
            body: this.formData,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '延期成功',
              type: 'success',
            })
            this.$emit('handleOk')
          }
          this.loading = false
        }
      })
    },
  },
  async created() {
    this.formData.id = this.FormData.id
    this.formData.hiddenDangerRectificationPeriod = dayjs(
      this.FormData.hiddenDangerRectificationPeriod
    ).format('YYYY-MM-DD HH:mm:ss')
    const userInfo = Wiz.AuthHooks.GetUserInfo()
    const { sub } = userInfo?.profile
    const userId = sub
    this.formData.hiddenDangerRectificationExtensionApplicantId = userId
    this.formData.hiddenDangerRectificationExtensionApplicationTime = dayjs().format(
      'YYYY-MM-DD HH:mm:ss'
    )
    this.$set(this.formData, 'receiverIds', [])
    await this.getWorkFlowDesign()
    await this.getWorkFlowNodes()
    this.getNodeConfirmUsers()
  },
}
</script>

<style scoped lang="scss"></style>
